import React, { useState, useEffect, useContext, useRef } from "react";
import { Row, Col, Form, Card, Button, Table, Image } from "react-bootstrap";
import PermissionContext from "../../Store/permission-context.js";
import classes from "./RegisterOrders.module.css";
import InputRadio from "../Elements/InputRadio.jsx";
import Receipt from "./Receipt.jsx";
import OrderReceipt from "./OrderReceipt.jsx";
import { AutoComplete, Divider } from "rsuite";
import "rsuite/dist/rsuite.css";
import { set } from "rsuite/esm/internals/utils/date/index.js";
const RegisterOrder = () => {
  const PCtx = useContext(PermissionContext);
  const [valval, setvalval] = useState("");
  const [Itemname, setItemname] = useState("");

  const [Nop, setNop] = useState("");
  const [Nou, setNou] = useState("");
  const [display, setdisplay] = useState(false);
  const [cannotGenerate, setcannotGenerate] = useState(true);
  const [showReceipt, setshowReceipt] = useState(false);
  const [QBulkError, setQBulkError] = useState(false);
  const [QUnitError, setQUnitError] = useState(false);
  const [AllGoodsIDs, setAllGoodsIDs] = useState([]);
  const [ErrorMsg, setErrorMsg] = useState(false);
  const [OrderNumber, setOrderNumber] = useState("");
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [AllOrderedItems, setAllOrderedItems] = useState([]);
  const [TotalPayable, setTotalPayable] = useState(0);
  const [SurCharge, setSurCharge] = useState(0);
  const [TotalPayableWithDiscount, setTotalPayableWithDiscount] = useState(0);
  const [showDiscount, setshowDiscount] = useState(false);
  const [Discount, setDiscount] = useState("0");
  const [PaymentMode, setPaymentMode] = useState("Cash");
  const [CustomerName, setCustomerName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("080XXXXXXXX");
  const [OpenCustomerForm, setOpenCustomerForm] = useState(true);
  const [OrderInProgress, setOrderInProgress] = useState(true);
  const [CheckOver, setCheckOver] = useState(true);
  const [CustomerChecked, setCustomerChecked] = useState(false);
  const tableRef = useRef(null);
  const [ReceiptDetails, setReceiptDetails] = useState({});
  const [GoodsNotAvailable, setGoodsNotAvailable] = useState([]);
  const [RegisteredPhone, setRegisteredPhone] = useState([]);
  const [RegisteredNames, setRegisteredNames] = useState([]);
  const [RegisteredID, setRegisteredID] = useState([]);
  const [PickedRegisteredName, setPickedRegisteredName] = useState("");
  const [PickedCustomerID, setPickedCustomerID] = useState("");
  const [PickedCustomerPhone, setPickedCustomerPhone] = useState("");
  const [SetActionInComplete, setSetActionInComplete] = useState(true);
  const [ItemProps, setItemProps] = useState({
    ItemID: "",
    Converter: "",
    QBulk: "",
    QUnit: "",
    SoldIn: "",
    SP1: "",
    SP2: "",
    SP3: "",
    UP1: "",
    UP2: "",
    UP3: "",
    PackPriceSelected: "",
    UnitPriceSelected: "",
    PUrl: "",
  });
  const [UneditItemname, setUneditItemname] = useState(false);

  var CryptoJS = require("crypto-js");
  // To load stored items from the database
  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");

      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    getData();
    setAllGoodNames(Allnames);
    setAllGoodsIDs(AllIDs);
  }, []);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollTop = tableRef.current.scrollHeight;
    }
  }, [AllOrderedItems]);

  useEffect(() => {
    if (AllOrderedItems.length > 0) {
      setcannotGenerate(false);
    } else {
      setcannotGenerate(true);
    }
  }, [AllOrderedItems]);

  useEffect(() => {
    const Proceed = async () => {
      if (GoodsNotAvailable.length === 0) {
        let rcd = Date.now() + Math.floor(Math.random() * 100 + 0);
        rcd = rcd.toString();
        rcd = rcd.substring(2);
        rcd = "R" + rcd;
        let receiptdate =
          new Date().toDateString() + ", " + new Date().toLocaleTimeString();

        setTotalPayableWithDiscount(TotalPayableWithDiscount + SurCharge);
        let RegisterOrdersData = {
          OrderData: AllOrderedItems,
          Discount: Discount,
          Payable: TotalPayable,
          PayableWithDiscount: TotalPayableWithDiscount,
          PaymentMode: PaymentMode,
          cn: CustomerChecked ? PickedRegisteredName : CustomerName,
          pn: PhoneNumber,
          ShowReceipt: true,
          rcn: rcd,
          rdt: receiptdate,
          Staff: PCtx.Username,
          cstid: PickedCustomerID,
        };
        let OrdersSaved = await PCtx.connectAxios(
          "registerorders.php",
          RegisterOrdersData,
        );
        // console.log(OrdersSaved);
        if (!OrdersSaved.includes("Error")) {
          RegisterOrdersData = { ...RegisterOrdersData, ON: OrdersSaved };
          setOrderNumber(OrdersSaved);
          setReceiptDetails(RegisterOrdersData);
          setOrderInProgress(false);
          setshowReceipt(true);
        }
      } else {
        let unavailable = "";
        for (var b = 0; b < GoodsNotAvailable.length; b++) {
          let newunv =
            b === GoodsNotAvailable.length - 1
              ? GoodsNotAvailable[b]
              : GoodsNotAvailable[b] + ",\n ";
          unavailable = unavailable + newunv;
        }

        PCtx.displayAlert(
          "INSUFFICIENT QUANTITY",
          "The following goods have just been sold out and are no longer available in the stock.\n" +
            unavailable,
          "danger",
        );
      }
    };

    if (AllOrderedItems.length > 0) {
      Proceed();
    }
  }, [CheckOver]);

  useEffect(() => {
    setUneditItemname(false);
    if (AllOrderedItems.length > 0 && Itemname !== "") {
      setSetActionInComplete(false);
    }
  }, [ItemProps]);

  const decryption = (Scramb) => {
    let Permission = false;
    if (PCtx.logged) {
      // Scramb = "U2FsdGVkX1/WscdZ+9IV7bHNnXe+9Ptb9Fcv1faThVI=";
      let Scrambled = Scramb.replace(/\s/g, "");
      var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
      let Allowance = bytes.toString(CryptoJS.enc.Utf8);
      Permission = parseInt(Allowance) === 1 ? true : false;
    }
    return Permission;
  };

  const getItemnameSelection = async (it) => {
    setUneditItemname(true);
    setSetActionInComplete(true);

    let goodproperties = await PCtx.connectAxios(
      `getitemdetails.php?version=${Date.now()}`,
      it,
    );
    // console.log(goodproperties);

    setItemProps({
      ItemID: goodproperties.GoodID,
      Converter: goodproperties.Converter,
      QBulk: goodproperties.QBulk,
      QUnit: goodproperties.QUnit,
      SoldIn: goodproperties.Soldin,
      SP1: parseFloat(goodproperties.SP1),
      SP2: parseFloat(goodproperties.SP2),
      SP3: parseFloat(goodproperties.SP3),
      UP1: parseFloat(goodproperties.UP1),
      UP2: parseFloat(goodproperties.UP2),
      UP3: parseFloat(goodproperties.UP3),
      PackPriceSelected: parseFloat(goodproperties.SP1),
      UnitPriceSelected: parseFloat(goodproperties.UP1),
      PUrl: goodproperties.PUrl,
    });
    console.log("Ser");
    setdisplay(true);
    setNop("");
    setNou("");
  };

  const secondGetItemnameSelection = async (it) => {
    let Nop = it.nop;
    let Nou = it.nou;
    let itnm = it.ordername;

    let goodproperties = await PCtx.connectAxios(
      `getitemdetails.php?version=${Date.now()}`,
      itnm,
    );

    let Converter = goodproperties.Converter;
    let QB = goodproperties.QBulk;
    let QU = goodproperties.QUnit;

    let NP = Nop === "" || Nop === null ? 0 : parseFloat(Nop);
    let NU = Nou === "" || Nou === null ? 0 : parseFloat(Nou);
    QB = QB === "" || QB === null ? 0 : parseFloat(QB);
    QU = QU === "" || QU === null ? 0 : parseFloat(QU);
    let thisorder = parseFloat(Converter) * parseFloat(NP) + parseFloat(NU);
    let availableorder = parseFloat(Converter) * QB + QU;

    if (availableorder < thisorder) {
      await setGoodsNotAvailable((prevGoodsNotAvailable) => [
        ...prevGoodsNotAvailable,
        itnm,
      ]);
    }
  };

  const ReConfirmOrderAvailability = async (TheOrders) => {
    setcannotGenerate(true);
    setGoodsNotAvailable([]);
    for (var r = 0; r < TheOrders.length; r++) {
      let theReturn = await secondGetItemnameSelection(TheOrders[r]);
      if (r == TheOrders.length - 1) {
        setCheckOver(!CheckOver);
      }
    }
  };

  const getTypedText = () => {
    if (Itemname === "") {
      setdisplay(false);
      setErrorMsg(false);
      setItemProps({
        ItemID: "",
        Converter: "",
        QBulk: "",
        QUnit: "",
        SoldIn: "",
        SP1: "",
        SP2: "",
        SP3: "",
        UP1: "",
        UP2: "",
        UP3: "",
        PackPriceSelected: "",
        UnitPriceSelected: "",
        PUrl: "",
      });
    } else {
      let ITN = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);
      if (AllGoodNames.includes(ITN)) {
        getItemnameSelection(ITN);
      } else {
        setItemProps({
          ItemID: "",
          Converter: "",
          QBulk: "",
          QUnit: "",
          SoldIn: "",
          SP1: "",
          SP2: "",
          SP3: "",
          UP1: "",
          UP2: "",
          UP3: "",
          PackPriceSelected: "",
          UnitPriceSelected: "",
          PUrl: "",
        });
        setdisplay(false);
        setErrorMsg(true);
      }
    }
  };

  const setTheValue = (e) => {
    let nm = e.target.name;
    let vl = e.target.value;
    if (nm === "nop" && !isNaN(vl)) {
      setNop(vl);
      setQBulkError(true);
    } else {
      if (nm === "nou" && !isNaN(vl)) {
        setNou(vl);
        setQUnitError(true);
      } else {
        if (nm === "custname") {
          setCustomerName(vl);
        } else {
          if (nm === "custphone") {
            setPhoneNumber(vl);
          }
        }
      }
    }
  };

  const radioPriceChanged = (e) => {
    if (e.target.checked) {
      if (e.target.name === "PriceBulk") {
        setItemProps({ ...ItemProps, PackPriceSelected: e.target.value });
      } else {
        if (e.target.name === "PriceUnit") {
          setItemProps({ ...ItemProps, UnitPriceSelected: e.target.value });
        }
      }
    }
  };

  const RemovingItems = async (dsIt, amt) => {
    await removeItem(dsIt, amt);
    if (PaymentMode === "Transfer" || PaymentMode === "POS") {
      await removeItem(PaymentMode + " Charges", SurCharge);
    }
  };

  const removeItem = async (dsItem, amount) => {
    await setAllOrderedItems((prevAllOrderedItems) =>
      prevAllOrderedItems.filter((itm) => itm.ordername !== dsItem),
    );
    await setTotalPayableWithDiscount(
      (prevTotalPayable) => prevTotalPayable - amount,
    );
    await setTotalPayable((prevTotalPayable) => prevTotalPayable - amount);
    if (showDiscount && Discount > 0) {
      setshowDiscount(false);
      setDiscount(0);
      PCtx.displayAlert(
        "DISCOUNT RESET",
        "Please note that the discount is no longer applied. You can reapply it after all your orders have been concluded",
        "warning",
      );
    }
    setSurCharge(0);
    setPaymentMode("Cash");
  };

  const getOrderDetails = async (e) => {
    e.preventDefault();
    setUneditItemname(true);
    setSetActionInComplete(true);
    let Ck = false;
    for (var m = 0; m < AllOrderedItems.length; m++) {
      let AOI = { ...AllOrderedItems[m] };
      if (AOI.ordername === Itemname) {
        Ck = true;
        setNop("");
        setNou("");
        break;
      }
    }
    if (!Ck) {
      let TotalPrice = 0;
      let NP = Nop === "" || Nop === null ? 0 : parseFloat(Nop);
      let NU = Nou === "" || Nou === null ? 0 : parseFloat(Nou);
      let QB =
        ItemProps.QBulk === "" ||
        ItemProps.QBulk === null ||
        ItemProps.SoldIn === "Unit"
          ? 0
          : parseFloat(ItemProps.QBulk);
      let QU =
        ItemProps.QUnit === "" || ItemProps.QUnit === null
          ? 0
          : parseFloat(ItemProps.QUnit);
      console.log(ItemProps.PackPriceSelected);
      console.log(ItemProps.PackPriceSelected);
      let psp =
        ItemProps.PackPriceSelected === "" ||
        ItemProps.PackPriceSelected === null ||
        isNaN(ItemProps.PackPriceSelected)
          ? 0
          : parseFloat(ItemProps.PackPriceSelected);
      let usp =
        ItemProps.UnitPriceSelected === "" ||
        ItemProps.UnitPriceSelected === null ||
        isNaN(ItemProps.UnitPriceSelected)
          ? 0
          : parseFloat(ItemProps.UnitPriceSelected);

      let thisorder =
        parseFloat(ItemProps.Converter) * parseFloat(NP) + parseFloat(NU);

      let availableorder = parseFloat(ItemProps.Converter) * QB + QU;

      console.log("thisorder", thisorder);
      console.log("availableorder", availableorder);

      if (availableorder >= thisorder) {
        TotalPrice = NP * psp + NU * usp;

        let desc;
        if (NP === 0 && NU > 0) {
          desc = NU + " Unit(s)";
        } else {
          if (NU === 0 && NP > 0) {
            desc = NP + " " + ItemProps.SoldIn + "(s)";
          } else {
            if (NP > 0 && NU > 0) {
              desc = NP + " " + ItemProps.SoldIn + "(s) and " + NU + " Units";
            }
          }
        }
        console.log("TotalPrice", TotalPrice);
        if (TotalPrice > 0 && !isNaN(TotalPrice)) {
          if (PaymentMode === "Transfer" || PaymentMode === "POS") {
            await removeItem(PaymentMode + " Charges", SurCharge);
          }
          let ordereddetails = {
            description: desc + " of " + Itemname,
            itemid: ItemProps.ItemID,
            ordername: Itemname,
            bulkprice: ItemProps.PackPriceSelected,
            unitprice: ItemProps.UnitPriceSelected,
            subtotal: TotalPrice,
            nop: NP,
            nou: NU,
            converter: ItemProps.Converter,
            rdesc: desc,
          };
          setAllOrderedItems((prevAllOrderedItems) => [
            ...prevAllOrderedItems,
            ordereddetails,
          ]);

          setTotalPayable((prevTotalPayable) => prevTotalPayable + TotalPrice);
          setTotalPayableWithDiscount(
            (prevTotalPayable) => prevTotalPayable + TotalPrice,
          );
          setItemname("");
          setNop("");
          setNou("");
          setItemProps({
            ItemID: "",
            Converter: "",
            QBulk: "",
            QUnit: "",
            SoldIn: "",
            SP1: "",
            SP2: "",
            SP3: "",
            UP1: "",
            UP2: "",
            UP3: "",
            PackPriceSelected: "",
            UnitPriceSelected: "",
            PUrl: "",
          });
          if (showDiscount && Discount > 0) {
            setUneditItemname(false);
            setshowDiscount(false);
            setDiscount(0);
            PCtx.displayAlert(
              "DISCOUNT RESET",
              "Please note that the discount is no longer applied. You can reapply it after all your orders have been concluded",
              "warning",
            );
          }
        } else {
          setUneditItemname(false);
          PCtx.displayAlert(
            "PRICE ERROR",
            "Please Check the Price and Quantity you picked",
            "danger",
          );
        }
      } else {
        setUneditItemname(false);
        PCtx.displayAlert(
          "INSUFFICIENT QUANTITY",
          "The available quantity of " +
            Itemname +
            " in stock is not enough for the ordered quantity. Please add to the stock or order for lesser quantity",
          "danger",
        );
      }
    } else {
      setUneditItemname(false);
      PCtx.displayAlert(
        "ITEM PICKED ALREADY",
        Itemname +
          " has been picked already in your ordered list. If you wish change the quantity of " +
          Itemname +
          ", delete from the placed ordered list and order again",
        "warning",
      );
    }
  };

  const getCustomerDetails = (e) => {
    e.preventDefault();
    if (CustomerChecked) {
      if (RegisteredNames.includes(PickedRegisteredName)) {
        setCustomerName(PickedRegisteredName);
        setPhoneNumber(PickedCustomerPhone);
        setOpenCustomerForm(false);
      } else {
        PCtx.displayAlert(
          "ERROR",
          PickedRegisteredName +
            " is not a registered name. Kindly register it first before you continue",
          "warning",
        );
      }
    } else {
      setCustomerName(CustomerName.toUpperCase());
      setOpenCustomerForm(false);
    }
  };

  const PaymentModeHandler = (e) => {
    setPaymentMode(e.target.value);
    let Pm = e.target.value;

    let IncomingTotal = TotalPayable;
    let IncomingTotalDiscount = TotalPayableWithDiscount;
    IncomingTotal = IncomingTotal - SurCharge;
    IncomingTotalDiscount = IncomingTotalDiscount - SurCharge;

    let newAllItem = AllOrderedItems.filter((AOI) => AOI.itemid != "12345");
    setAllOrderedItems(newAllItem);
    setSurCharge(0);
    setTotalPayable(IncomingTotal);
    setTotalPayableWithDiscount(IncomingTotalDiscount);
    if (Pm === "Transfer" || Pm === "POS") {
      let Charges = 0;
      if (Pm === "Transfer") {
        if (IncomingTotalDiscount < 1000) {
          Charges = 10;
        }

        if (IncomingTotalDiscount >= 1000 && IncomingTotalDiscount <= 9999) {
          Charges = 20;
        }

        if (IncomingTotalDiscount >= 10000 && IncomingTotalDiscount <= 49999) {
          Charges = 50;
        }
        if (IncomingTotalDiscount >= 50000 && IncomingTotalDiscount <= 99999) {
          Charges = 50;
        }
        if (IncomingTotalDiscount >= 100000) {
          Charges = 70;
        }
      } else {
        if ((Pm = "POS")) {
          if (IncomingTotalDiscount <= 4999) {
            Charges = 50;
          } else {
            Charges = 100;
          }
        }
      }
      let PaymentOrder = {
        description: "Charges on " + Pm,
        itemid: "12345",
        ordername: Pm + " Charges",
        bulkprice: Charges,
        unitprice: 0,
        subtotal: Charges,
        nop: 1,
        nou: 1,
        rdesc: "",
      };
      setSurCharge(Charges);
      setTotalPayable(IncomingTotal + Charges);
      setTotalPayableWithDiscount(IncomingTotalDiscount + Charges);
      setAllOrderedItems((prevAllOrderedItems) => [
        ...prevAllOrderedItems,
        PaymentOrder,
      ]);
    }
  };

  const ApplyDiscount = (e) => {
    let dsc = e.target.value;
    if (showDiscount && TotalPayable > 0 && !isNaN(dsc)) {
      let discount = parseFloat(dsc) > 0 ? parseFloat(dsc) : 0;
      setDiscount(discount);
      setTotalPayableWithDiscount(parseFloat(TotalPayable) - discount);
    }
  };

  const ShowDiscountHandler = () => {
    setshowDiscount(!showDiscount);
    if (showDiscount) {
      setDiscount(0);
      setTotalPayableWithDiscount(TotalPayable);
    }
  };

  const StartNewRegisterOrders = () => {
    window.location.reload();
  };

  const getCustomerSelected = (cst) => {
    setPickedRegisteredName(cst);

    let ind = RegisteredNames.findIndex((customer) => customer === cst);
    setPickedCustomerPhone(RegisteredPhone[ind]);
    setPickedCustomerID(RegisteredID[ind]);
  };

  const checkBoxHandler = async (e) => {
    let checker = e.target.checked;
    setCustomerChecked(checker);
    if (checker) {
      let RC = await PCtx.connectAxios("getallcustomers.php", "");

      if (!RC.includes("Error")) {
        let RegNames = [];
        let RegID = [];
        let RegPhone = [];
        for (var t = 0; t < RC.length; t++) {
          RegNames = [...RegNames, RC[t].BusinessName];
          RegID = [...RegID, RC[t].CustomerID];
          RegPhone = [...RegPhone, RC[t].PhoneNumber];
        }
        setRegisteredNames(RegNames);
        setRegisteredID(RegID);
        setRegisteredPhone(RegPhone);
      }
    } else {
      setPickedRegisteredName("");
    }
  };
  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">Register Orders</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {OpenCustomerForm && (
          <Row className="mt-5 justify-content-around">
            <Col md={4} sm={12} xs={12}>
              <Form onSubmit={getCustomerDetails}>
                <Card>
                  <Card.Header>Customer's Details</Card.Header>
                  <Card.Body>
                    <Form.Group className="mb-0" controlId={valval}>
                      <Form.Label
                        style={{
                          color: "brown",
                          paddingBottom: "0px",
                          marginBottom: "0px",
                        }}
                      >
                        Customer's Name
                      </Form.Label>
                      <br />
                      <input type="checkbox" onChange={checkBoxHandler} />
                      Registered Customer
                      {!CustomerChecked ? (
                        <Form.Control
                          type="text"
                          value={CustomerName}
                          name="custname"
                          onChange={setTheValue}
                        />
                      ) : (
                        <AutoComplete
                          data={RegisteredNames}
                          value={PickedRegisteredName.toUpperCase()}
                          onChange={setPickedRegisteredName}
                          onSelect={getCustomerSelected}
                          style={{
                            border: "1px solid brown",
                            backgroundColor: "#b3ff66",
                            borderRadius: "3px",
                          }}
                        />
                      )}
                    </Form.Group>
                    <Form.Group className="mt-3" controlId={valval}>
                      <Form.Label style={{ color: "brown" }}>
                        Customer's Phone Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          !CustomerChecked ? PhoneNumber : PickedCustomerPhone
                        }
                        name="custphone"
                        onChange={setTheValue}
                      />
                    </Form.Group>
                  </Card.Body>
                  <Card.Footer>
                    <Row className="justify-content-end">
                      <Col md={4} sm={4} xs={4}>
                        <Button variant="info" type="submit">
                          Start Order
                        </Button>
                      </Col>
                    </Row>
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Row>
        )}
        {!OpenCustomerForm && (
          <Row className="justify-content-around">
            {OrderInProgress && (
              <Col
                md={{ span: 4, order: 1 }}
                sm={{ span: 12, order: 2 }}
                xs={{ span: 12, order: 2 }}
                className={classes.hide4printing}
              >
                <Row className={classes.hide4printing}>
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Header>
                        PLACED ORDERS FOR {CustomerName.toUpperCase()}
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col
                            md={12}
                            sm={12}
                            ref={tableRef}
                            style={{
                              height: "300px",
                              overflowY: "auto",
                              marginButtom: "20px",
                            }}
                          >
                            <Table
                              striped
                              bordered
                              hover
                              style={{ fontFamily: "Times New Roman" }}
                            >
                              <thead>
                                <tr>
                                  <th className={classes.PlacedOrderTableTd}>
                                    SN
                                  </th>
                                  <th className={classes.PlacedOrderTableTd}>
                                    Description
                                  </th>
                                  <th className={classes.PlacedOrderTableTd}>
                                    Bulk Price
                                  </th>
                                  <th className={classes.PlacedOrderTableTd}>
                                    Unit Price
                                  </th>
                                  <th className={classes.PlacedOrderTableTd}>
                                    Sub Total
                                  </th>
                                  <th className={classes.PlacedOrderTableTd}>
                                    Delete
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {AllOrderedItems.map((order, index) => (
                                  <tr key={index}>
                                    <td className={classes.PlacedOrderTableTd}>
                                      {index + 1}
                                    </td>
                                    <td className={classes.PlacedOrderTableTd}>
                                      {order.description}
                                    </td>
                                    <td className={classes.PlacedOrderTableTd}>
                                      {isNaN(order.bulkprice)
                                        ? "-"
                                        : order.bulkprice}
                                    </td>
                                    <td className={classes.PlacedOrderTableTd}>
                                      {isNaN(order.unitprice)
                                        ? "-"
                                        : order.unitprice}
                                    </td>
                                    <td className={classes.PlacedOrderTableTd}>
                                      {order.subtotal}
                                    </td>
                                    <td className={classes.PlacedOrderTableTd}>
                                      <Button
                                        variant="danger"
                                        type="button"
                                        className="btn-sm"
                                        disabled={
                                          order.itemid === "12345"
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          RemovingItems(
                                            order.ordername,
                                            order.subtotal,
                                          )
                                        }
                                      >
                                        -
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Body className="py-1">
                        <Row>
                          <Col
                            md={6}
                            style={{
                              borderRight: "1px solid brown",
                              visibility: "hidden",
                            }}
                          >
                            <label>
                              <input
                                type="checkbox"
                                onChange={ShowDiscountHandler}
                                checkd={showDiscount}
                              />
                              Discount
                            </label>
                            {showDiscount && (
                              <input
                                type="text"
                                placeholder="Enter Amount"
                                readOnly={TotalPayable <= 0}
                                value={Discount}
                                onChange={ApplyDiscount}
                                style={{
                                  width: "100px",
                                  marginLeft: "3px",
                                  borderRadius: "2px",
                                  paddingLeft: "5px",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card style={{ height: "30px" }}>
                      <Card.Body>
                        <Divider className="m-0">
                          <h4 className="text-success ">
                            Total Payable = ₦{TotalPayableWithDiscount}
                          </h4>
                        </Divider>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12}>
                    <Button
                      variant="success"
                      className="w-100 mt-1"
                      onClick={() =>
                        ReConfirmOrderAvailability(AllOrderedItems)
                      }
                      disabled={cannotGenerate}
                    >
                      SEND ORDER FOR PAYMENT
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}
            {!OrderInProgress && (
              <Row className="justify-content-around mt-2">
                {/* <Col md={5} lg={5} sm={12} className="mt-2">
                  <Button
                    variant="success"
                    className={`${classes.hide4printing} ${"w-100"}`}
                    onClick={() => window.print()}
                  >
                    PRINT ORDER
                  </Button>
                </Col> */}
                <Col md={5} lg={5} sm={12} className="mt-2">
                  <Button
                    variant="info"
                    className={`${classes.hide4printing} ${"w-100"}`}
                    onClick={StartNewRegisterOrders}
                  >
                    START NEW ORDER
                  </Button>
                </Col>
              </Row>
            )}
            {OrderInProgress && (
              <Col
                md={{ span: 4, order: 2 }}
                lg={{ span: 4, order: 2 }}
                sm={{ span: 12, order: 1 }}
                xs={{ span: 12, order: 1 }}
                className={classes.hide4printing}
              >
                <Card>
                  <Card.Header>NEW ITEM SALE</Card.Header>
                  <Card.Body>
                    <Form onSubmit={getOrderDetails}>
                      <Row className="justify-content-around">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label style={{ color: "brown" }}>
                              Item Name
                            </Form.Label>
                            <AutoComplete
                              data={AllGoodNames}
                              value={
                                Itemname.charAt(0).toUpperCase() +
                                Itemname.slice(1)
                              }
                              onChange={setItemname}
                              onSelect={getItemnameSelection}
                              onBlur={getTypedText}
                              readOnly={UneditItemname}
                              style={{ border: "1px solid brown" }}
                            />

                            {display ? (
                              <p className="mx-0">
                                {!(
                                  ItemProps.SoldIn === "Piece" ||
                                  ItemProps.SoldIn === "Unit"
                                ) &&
                                  ItemProps.SoldIn +
                                    "s left: " +
                                    ItemProps.QBulk +
                                    " | "}
                                Units left: {ItemProps.QUnit}
                              </p>
                            ) : ErrorMsg &&
                              !AllGoodNames.includes(
                                Itemname.charAt(0).toUpperCase() +
                                  Itemname.slice(1),
                              ) ? (
                              <p className="mx-0 text-danger">
                                {Itemname} does not exist in stock. Please Check
                                the spelling and try again
                              </p>
                            ) : null}
                          </Form.Group>
                          <hr className="m-3 p-0" />
                        </Col>

                        {!(
                          ItemProps.SoldIn === "Unit" ||
                          ItemProps.SoldIn === "Piece"
                        ) && (
                          <Col md={12}>
                            <Form.Group className="mb-0" controlId={valval}>
                              <Form.Label style={{ color: "brown" }}>
                                {"How many " + ItemProps.SoldIn + "s?"}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={Nop}
                                readOnly={
                                  !display ||
                                  (!ItemProps.SP1 &&
                                    !ItemProps.SP2 &&
                                    !ItemProps.SP3)
                                }
                                name="nop"
                                onChange={setTheValue}
                                style={{
                                  backgroundColor: "White",
                                  border: "1px solid brown",
                                }}
                              />
                            </Form.Group>
                            <InputRadio
                              MyStyle={{ fontSize: "12px" }}
                              className={classes.RadioPrice}
                              price={ItemProps.SP1}
                              disab={false}
                              lab="1"
                              Name="PriceBulk"
                              myChange={radioPriceChanged}
                              checkd={
                                parseFloat(ItemProps.SP1) ===
                                parseFloat(ItemProps.PackPriceSelected)
                              }
                            />
                            {decryption(PCtx.PR) && (
                              <InputRadio
                                MyStyle={{ fontSize: "12px" }}
                                price={ItemProps.SP2}
                                disab={false}
                                lab="2"
                                Name="PriceBulk"
                                myChange={radioPriceChanged}
                                checkd={
                                  parseFloat(ItemProps.SP2) ===
                                  parseFloat(ItemProps.PackPriceSelected)
                                }
                              />
                            )}
                            {decryption(PCtx.PR) && (
                              <InputRadio
                                MyStyle={{ fontSize: "12px" }}
                                price={ItemProps.SP3}
                                disab={false}
                                lab="3"
                                Name="PriceBulk"
                                myChange={radioPriceChanged}
                                checkd={
                                  parseFloat(ItemProps.SP3) ===
                                  parseFloat(ItemProps.PackPriceSelected)
                                }
                              />
                            )}
                            <hr className="m-3 p-0" />
                          </Col>
                        )}
                        <Col md={12}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label style={{ color: "brown" }}>
                              How many Units/Pieces?
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={Nou}
                              name="nou"
                              readOnly={
                                !display ||
                                (!ItemProps.UP1 &&
                                  !ItemProps.UP2 &&
                                  !ItemProps.UP3)
                              }
                              onChange={setTheValue}
                              style={{
                                backgroundColor: "White",
                                border: "1px solid brown",
                              }}
                            />
                          </Form.Group>
                          <InputRadio
                            MyStyle={{ fontSize: "12px" }}
                            price={ItemProps.UP1}
                            disab={false}
                            Name="PriceUnit"
                            lab="1"
                            myChange={radioPriceChanged}
                            checkd={
                              parseFloat(ItemProps.UP1) ===
                              parseFloat(ItemProps.UnitPriceSelected)
                            }
                          />
                          {decryption(PCtx.PR) && (
                            <InputRadio
                              MyStyle={{ fontSize: "12px" }}
                              price={ItemProps.UP2}
                              disab={false}
                              Name="PriceUnit"
                              lab="2"
                              myChange={radioPriceChanged}
                              checkd={
                                parseFloat(ItemProps.UP2) ===
                                parseFloat(ItemProps.UnitPriceSelected)
                              }
                            />
                          )}
                          {decryption(PCtx.PR) && (
                            <InputRadio
                              MyStyle={{ fontSize: "12px" }}
                              price={ItemProps.UP3}
                              disab={false}
                              Name="PriceUnit"
                              lab="3"
                              myChange={radioPriceChanged}
                              checkd={
                                parseFloat(ItemProps.UP3) ===
                                parseFloat(ItemProps.UnitPriceSelected)
                              }
                            />
                          )}
                          <hr className="mt-2 mb-1 p-0" />
                        </Col>
                        <Col md={4} sm={4} xs={4} className="offset-4">
                          <Button
                            className="align-self-center"
                            variant="info"
                            type="submit"
                            disabled={
                              Nop === "" && Nou === "" && SetActionInComplete
                            }
                          >
                            Place Order
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            )}
            <Col
              md={{ span: 4, order: 5 }}
              lg={{ span: 4, order: 5 }}
              sm={{ span: 12, order: 3 }}
              xs={{ span: 12, order: 3 }}
              className="p-4"
            >
              <Card>
                <Card.Body className={classes.margin4printing}>
                  {showReceipt ? (
                    <OrderReceipt Rct={ReceiptDetails} PrintDirectly={true} />
                  ) : (
                    <Image
                      src={`/applauseinfotech/phpfiles/${
                        ItemProps.PUrl
                      }?version=${Date.now()}`}
                      alt="Item Image"
                      thumbnail
                      style={{ width: "100%", height: "300px" }}
                    />
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default RegisterOrder;
